module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAMAAABYzB2OAAAAOVBMVEUAAAD//v6QkJHGxsbf39/x8fE6Ojw9PT1GRkZRUVFpaWlwcHCIiIiioqKxsbEEBAQeHh4NDg4pKSk48VfqAAAAD3RSTlMAA4tHJRD18ubZu7GVdGCDdXy6AAAAN0lEQVQI12MgCzCSpJqHn5OFgYGVm58NLsQswC/IxAciGOGmsXLxAwEHC4r5zOxCvKS4ihGLIAB/dAFKimHupQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/down-arrow.png
// module id = 990
// module chunks = 7